import React from 'react';

export default function GooglePlayButtonBlack() {

  return (
    <img src={require(`../images/badge-play-store-black.png`)} alt="Google Play badge"/> 
  )
}
